import React from 'react';
import { StarIcon } from 'lucide-react';
import { reviews } from '../../data/reviews';
export function ReviewsWall() {
  return <section className="border-t border-ink/10 px-6 py-16" aria-labelledby="reviews-heading" data-id="element-93" data-mp="1c6maw4gybnct">
      <div className="mx-auto max-w-4xl" data-id="element-94" data-mp="1gatwvtw0yp7c">
        <Stars className="justify-center" size="h-3.5 w-3.5" data-id="element-95" data-mp="1g7pjc5wo6h40" />
        <h2 id="reviews-heading" className="mt-3 text-center font-display text-3xl text-ink" data-id="element-96" data-mp="1l83kr53rmst2">
          What couples &amp; guests <em className="text-gold" data-id="element-97" data-mp="og9sfzo2y87z">say</em>
        </h2>
        <p className="mt-2 text-center font-body text-sm text-ink/60" data-id="element-98" data-mp="skznxnettksd">
          Real reviews from our Google profile
        </p>
        <ul className="mt-10 columns-1 gap-4 sm:columns-2 md:columns-3" data-id="element-99" data-mp="xhq0w1vc409k">
          {reviews.map((review, i) => <li key={review.name} className="mb-4 break-inside-avoid border border-ink/10 bg-white p-4" data-id="element-100" data-mp="12blwixo4lb1k" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-101" data-mp="9soroceogl38">
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full font-sans text-[11px] font-semibold text-white ${i % 2 === 0 ? 'bg-ink' : 'bg-gold'}`} aria-hidden="true" data-id="element-102" data-mp="9r3wqlogb04u">
                  {review.name.charAt(0)}
                </span>
                <div className="min-w-0" data-id="element-103" data-mp="1y4iqb9vok3od">
                  <p className="truncate font-sans text-xs font-semibold text-ink" data-id="element-104" data-mp="1t5xpp9cinhze">{review.name}</p>
                  <p className="font-sans text-[10px] text-ink/50" data-id="element-105" data-mp="1o6uipjcz71os">{review.when}</p>
                </div>
              </div>
              <Stars className="mt-2.5" size="h-3 w-3" data-id="element-106" data-mp="1k4hdcw2555sj" />
              <p className="mt-2 font-body text-[14px] leading-relaxed text-ink/75" data-id="element-107" data-mp="1k7de0s5di8ko">{review.text}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}
function Stars({
  className = '',
  size
}: {
  className?: string;
  size: string;
}) {
  return <div className={`flex gap-0.5 ${className}`} role="img" aria-label="5 out of 5 stars" data-id="element-108" data-mp="39lif3vitk0dn">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`${size} fill-gold text-gold`} aria-hidden="true" data-id="element-109" data-mp="3smzi6s7mt9jb" data-mpi={i} />)}
    </div>;
}